import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import { withRouter } from 'react-router-dom';
import { getUserDashboardInfo, deleteUser } from '../../store/actions';
import ComponentHeader from '../ecap/ComponentHeader';
import { getAdminState, getAuthState } from '../../store/selectors';

// Define styles using JSS
const useStyles = createUseStyles({
  button: (tenant) => ({
    color: 'white',
    borderColor: tenant?.primary,
    backgroundColor: tenant?.primary,
    padding: '0 34px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',

    '&:hover': {
      border: `2px solid ${tenant?.primary}`,
      color: tenant?.primary,
      backgroundColor: 'white',
    },
    '&:disabled': {
      color: 'white',
      borderColor: tenant?.primary,
      backgroundColor: tenant?.primary,
      pointerEvents: 'none',
      opacity: 0.5,
    },
  }),
  dialogButton: {
    padding: '10px 34px',
    borderRadius: '40px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  primaryButton: (tenant) => ({
    border: `2px solid ${tenant?.primary}`,
    color: tenant?.primary,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: tenant?.primary,
      borderColor: tenant?.primary,
      color: 'white',
    },
  }),
});

const DeleteUser = (props) => {
  const [showDialog, setShowDialog] = useState(false);

  const { userProfileInfo } = props.admin;
  const tenant = userProfileInfo?.tenant || {};
  const userId = props.admin?.userProfileInfo?.id; // Assuming userId comes from auth state

  // Apply JSS styles
  const classes = useStyles(tenant);

  // Function to handle opening the dialog
  const openDialog = () => {
    setShowDialog(true);
  };

  // Function to handle user deletion (Yes button click)
  const handleSubmit = async () => {
    try {
      const res = await props.deleteUser(userId, props.auth.jwtToken); // Call the deleteUser action

      // Check if the deletion message exists in the response
      if (res && res.data && res.data.message) {
        setShowDialog(false); // Close the dialog after successful deletion

        // Navigate to the tenant-specific advisor dashboard users route
        props.history.push(`/${tenant?.name}/advisor-dashboard/users`);
      } else {
        console.error('Unexpected response format:', res);
      }
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  // Function to close the dialog (for both Yes and No actions)
  const closeDialog = () => {
    setShowDialog(false);
  };

  return (
    <div className="delete-user">
      <ComponentHeader
        parent="dashboard"
        headerText="Delete User"
        tenant={tenant}
      />
      <div className="bottom-row-container">
        <button
          type="button"
          tabIndex={0}
          className={`${classes.button} button--primary delete-user`}
          onClick={openDialog}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) openDialog();
          }}
        >
          Delete User
        </button>
      </div>
      {showDialog && (
        <div className="custom-dialog-overlay">
          <div className="custom-dialog">
            <h3>Are you sure you want to delete this user?</h3>
            <div className="dialog-buttons">
              <button
                type="button"
                className={`${classes.dialogButton} ${classes.primaryButton}`}
                onClick={closeDialog}
              >
                No
              </button>
              <button
                type="button"
                className={`${classes.dialogButton} ${classes.primaryButton}`}
                onClick={handleSubmit}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  admin: getAdminState(state),
  auth: getAuthState(state),
});

export default withRouter(
  connect(mapStateToProps, {
    getUserDashboardInfo,
    deleteUser, // Make sure deleteUser is connected here
  })(DeleteUser)
);
